var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconScalpHairvolumeLGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#939393",
    strokeWidth: 1.5,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.655 29c0-2.595-.667-3.484-1.246-3.243-3.115 1.297-4.984.648-4.984-.649 0-1.946-.623-3.243-.623-3.243-3.115-.649-1.246-2.595-1.246-2.595 1.869-3.243 1.032-3.475.623-4.54-1.246-3.244.623-5.838.623-5.838s2.089 4.372 5.607 5.838c3.07 1.279 11.588 1.927 8.849 10.64-.026.083.072.147.125.079 1.203-1.528 5.992-8.37-1.498-12.017C16.753 11.907 10.54 10.838 9.917 5M16.008 4s-.493 4.204 7.106 7.174c1.949.761 5.238 2.86 3.876 7.826 0 0 4.522-3.913 0-8.478"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScalpHairvolumeLGray);
export default __webpack_public_path__ + "static/media/icon_scalp_hairvolume_l_gray.ebfc2c9e.svg";
export { ForwardRef as ReactComponent };